export default __webpack_public_path__ + "static/media/whatIsJS.221458bd.md";